<template>
  <section class="h-100 pt-3" id="sales-resource-update">
    <div class="container h-100">
      <div class="row d-flex justify-content-center align-items-center h-100">
        <div class="col-12">
          <h2 class="title border-bottom pb-2 mb-4">
            Resources Updated in the Last {{ days }} Days
          </h2>
        </div>
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Name</th>
                  <th class="text-nowrap">Resource Type</th>
                  <th width="20%">Who Can This Be Shared With</th>
                  <th>Description</th>
                  <th class="text-nowrap">Last Update</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="resource in resources" :key="resource.id">
                  <td>
                    <a :href="getResourceLink(resource)" target="_blank">{{
                      resource.name
                    }}</a>
                  </td>
                  <td class="text-nowrap">{{ resource.type }}</td>
                  <td class="text-nowrap">
                    <div>
                      Tarana -
                      <font-awesome-icon
                        :icon="['fas', resource.tarana ? 'check' : 'xmark']"
                        :class="resource.tarana ? 'text-success' : 'text-danger'"
                      />
                    </div>
                    <div>
                      Distributor -
                      <font-awesome-icon
                        :icon="['fas', resource.distributor ? 'check' : 'xmark']"
                        :class="
                          resource.distributor ? 'text-success' : 'text-danger'
                        "
                      />
                    </div>
                    <div>
                      Customer -
                      <font-awesome-icon
                        :icon="['fas', resource.customer ? 'check' : 'xmark']"
                        :class="
                          resource.customer ? 'text-success' : 'text-danger'
                        "
                      />
                    </div>
                    <div>
                      Public -
                      <font-awesome-icon
                        :icon="['fas', resource.public ? 'check' : 'xmark']"
                        :class="resource.public ? 'text-success' : 'text-danger'"
                      />
                    </div>
                  </td>
                  <td>
                    <span v-html="$sanitize(resource.description || '-')"></span>
                  </td>
                  <td class="text-nowrap">{{ resource.rev_date }}</td>
                </tr>
                <tr v-if="!resources.length && !isLoading">
                  <td colspan="5" class="text-center">
                    No resources were updated in the past {{ days }} days.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="mt-3" v-if="resources.length">
            <h3>Audience Legend</h3>
            <ul class="ps-3">
              <li class="mb-2">
                <strong>Tarana:</strong> Internal Tarana employees.
              </li>
              <li class="mb-2">
                <strong>Distributor:</strong> Our network of six Master
                Distributors who stock inventory for resale to our 500+ end
                customers. While they function as resellers, we formally
                identify them as distributors. This group receives specialized
                communications, such as pricing updates and promotions,
                typically managed by Kyle.
              </li>
              <li class="mb-2">
                <strong>Customer:</strong> A company that has ordered from Tarana
                and holds a live contract.
              </li>
              <li class="mb-2">
                <strong>Public:</strong> Anyone, regardless of their relationship
                with Tarana.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      resources: [],
      days: 90,
      isLoading: false,
    };
  },
  computed: {
    getAPIUrl() {
      const base = this.$axios.defaults.baseURL;
      return base.split("/api")[0];
    },
  },
  created() {
    this.getRecentResources();
    this.updateActions("/sales-resource-update");
  },
  methods: {
    getRecentResources() {
      this.isLoading = true;
      let loader = this.$loading.show({
        canCancel: true,
        color: "#0367a9",
      });
      this.$axios
        .get("resources-recent", {})
        .then(
          function (response) {
            loader.hide();
            this.isLoading = false;
            this.days = response.data.days ?? 90;
            this.resources = response.data.resources ?? [];
          }.bind(this)
        )
        .catch(
          function () {
            loader.hide();
            this.isLoading = false;
          }.bind(this)
        );
    },
    getResourceLink(resource) {
      if (resource.resource_link) {
        return resource.resource_link;
      } else if (resource.semantic_url) {
        return `${this.getAPIUrl}/doc/${resource.semantic_url}`;
      } else {
        return `${this.getAPIUrl}/storage/${resource.file_path}`;
      }
    },
  },
};
</script>
